import { useAtomValue } from 'jotai'
import { match } from 'ts-pattern'
import { currentEditorStepAtom } from './editor.atoms'
import { StepCustomerAndLineItems, StepSummary, StepTerms } from './steps'

export const Editor = () => {
  const currentStep = useAtomValue(currentEditorStepAtom)

  return match(currentStep)
    .with('CUSTOMER_AND_LINE_ITEMS', () => <StepCustomerAndLineItems />)
    .with('TERMS', () => <StepTerms />)
    .with('SUMMARY', () => <StepSummary />)
    .exhaustive()
}
